function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ArgentinaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_4913",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18,
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_4913)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_4913",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_4913)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V9H24V3H0Z",
        fill: "#58A5FF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 15V21H24V15H0Z",
        fill: "#58A5FF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.4145 13.8654C12.4145 13.8654 11.6481 15.4544 10.9745 15.7802C11.2652 15.0514 11.3722 13.5643 11.3722 13.5643C11.3722 13.5643 9.62331 14.2577 9.00945 14.1313C9.74759 13.6155 10.7721 12.6602 10.7721 12.6602C10.7721 12.6602 8.50848 11.9201 8.56401 11.6052C9.58587 11.7885 10.9912 11.5886 10.9912 11.5886C10.9912 11.5886 9.40311 9.68422 9.56416 9.5426C9.80622 9.77789 11.7094 10.772 11.7094 10.772C11.7094 10.772 11.8475 9.07763 12.257 8.50635C12.3062 8.9096 12.881 10.7354 12.881 10.7354C12.881 10.7354 14.0367 9.57905 14.6781 9.57905C14.3964 9.92837 13.7293 11.4628 13.7293 11.4628C13.7293 11.4628 15.3919 11.4367 16.0239 11.7478C15.2583 11.8567 13.9168 12.5302 13.9168 12.5302C13.9168 12.5302 15.6639 13.8555 15.5046 14.1313C14.5666 13.6725 13.4822 13.5188 13.4822 13.5188C13.4822 13.5188 13.7819 15.3631 13.5396 15.7802C13.3033 15.1662 12.4145 13.8654 12.4145 13.8654Z",
        fill: "#FFD018",
        stroke: "#F19900",
        strokeOpacity: "0.98",
        strokeWidth: "0.25"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.314 13.0063C12.7282 13.0063 13.064 12.6706 13.064 12.2563C13.064 11.8421 12.7282 11.5063 12.314 11.5063C11.8998 11.5063 11.564 11.8421 11.564 12.2563C11.564 12.6706 11.8998 13.0063 12.314 13.0063Z",
        fill: "#FFD018",
        stroke: "#F19900",
        strokeOpacity: "0.98",
        strokeWidth: "0.25"
      })]
    })]
  })]
}));
//# sourceMappingURL=Argentina.js.map